export default __webpack_public_path__ + "static/media/good-mood-grey-haired-man-sitting-with-cup-hands-smiling (1).b23cba2c.jpg";